import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgNodeJs = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-node-js';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M7.592 4.613 3.243 7.06 3.242 12v4.94l1.14.64c.628.352 1.28.693 1.449.758.286.11.349.119.849.12.629.002.814-.045 1.268-.324.356-.219.653-.545.834-.914.29-.594.273-.31.288-4.81l.014-4.05H7.562l-.011 3.99-.011 3.99-.094.191a.78.78 0 0 1-.537.435c-.317.085-.533.012-1.389-.468l-.76-.426V7.935l3.587-2.018C10.32 4.808 11.964 3.9 12 3.9s1.68.908 3.653 2.017l3.587 2.018v8.135l-3.6 2.025c-1.98 1.114-3.619 2.025-3.641 2.025-.023 0-.393-.198-.822-.441-.43-.242-.796-.432-.814-.421-.04.025-.735 1.264-.717 1.279.008.006.535.304 1.172.662.961.54 1.173.645 1.248.616.049-.019 2.025-1.124 4.391-2.455l4.301-2.42V12l-.001-4.94-4.344-2.44c-2.389-1.342-4.373-2.443-4.409-2.447s-2.021 1.094-4.412 2.44m5.425 3.647c-.677.119-1.429.426-1.897.774a2.4 2.4 0 0 0-.901 1.34c-.072.308-.073.495-.001.833.091.43.241.698.579 1.036.536.537.869.646 2.544.835 2.405.271 3.095.433 3.366.787.26.341.085.915-.347 1.135-.656.335-2.582.493-3.526.291-.89-.191-1.238-.509-1.301-1.19l-.025-.261H9.995l.026.29c.12 1.314.818 2.164 2.082 2.53 1.347.39 3.789.24 4.887-.301 1.426-.702 1.802-2.547.734-3.599-.612-.603-1.422-.85-3.604-1.101-2.004-.229-2.061-.241-2.295-.491-.233-.249-.164-.662.152-.903.663-.506 1.823-.699 2.883-.481.96.197 1.492.53 1.64 1.027.033.112.06.227.06.256 0 .042.154.053.738.053.405 0 .745-.013.755-.03.032-.054-.054-.561-.135-.798-.342-.996-1.207-1.634-2.658-1.958-.563-.125-1.732-.164-2.243-.074"
    })
  }));
});
export default SvgNodeJs;